export const fragranceSizes = [
  { value: "5ML", label: "5 ML" },
  { value: "10ML", label: "10 ML" },
  { value: "15ML", label: "15 ML" },
  { value: "20ML", label: "20 ML" },
  { value: "25ML", label: "25 ML" },
  { value: "30ML", label: "30 ML" },
  { value: "35ML", label: "35 ML" },
  { value: "40ML", label: "40 ML" },
  { value: "45ML", label: "45 ML" },
  { value: "50ML", label: "50 ML" },
  { value: "55ML", label: "55 ML" },
  { value: "60ML", label: "60 ML" },
  { value: "65ML", label: "65 ML" },
  { value: "70ML", label: "70 ML" },
  { value: "75ML", label: "75 ML" },
  { value: "80ML", label: "80 ML" },
  { value: "85ML", label: "85 ML" },
  { value: "90ML", label: "90 ML" },
  { value: "95ML", label: "95 ML" },
  { value: "100ML", label: "100 ML" },
];
